import React from 'react';

const SelectLetra = (props) => {
  const letraActual = props.letraActual;
  const lista = [];
  for (let index = 65; index <= 90; index++) {
    lista.push(String.fromCharCode(index));
  }

  const onLetraElegida = (event) => {
    props.onLetraElegida(event.target.value);
  };

  return (
    <select value={letraActual} onChange={onLetraElegida}>
      <option key="" value=""></option>
      {lista.map((letra, index) => (
        <option key={index} value={letra}>
          {letra}
        </option>
      ))}
    </select>
  );
};

export default SelectLetra;
